import { type FieldValues } from 'react-hook-form';

import { ScorePerQuestionFormField } from '../../components';
import {
  ItemSetQuestionConditionsSection,
  type ItemSetQuestionConditionsSectionProps,
} from '../../containers';

interface QConfigItemSetQuestionPropertiesFormFieldsProps<
  TFieldValues extends FieldValues & {
    itemSetType?: number;
    conditions: Array<unknown>;
  },
> extends ItemSetQuestionConditionsSectionProps<TFieldValues> {
  itemSetType: number;
}

export default function QConfigItemSetQuestionPropertiesFormFields<
  TFieldValues extends FieldValues & { itemSetType?: number; conditions: Array<unknown> },
>(props: Readonly<QConfigItemSetQuestionPropertiesFormFieldsProps<TFieldValues>>) {
  const {
    itemSetType,
    onApplyConditions,
    isLoading: isApplyingConditionsLoading,
    formContext,
  } = props;
  return (
    <>
      <ScorePerQuestionFormField />
      {itemSetType ? (
        <ItemSetQuestionConditionsSection
          onApplyConditions={onApplyConditions}
          isLoading={isApplyingConditionsLoading}
          formContext={formContext}
        />
      ) : null}
    </>
  );
}
